import { createSelector } from '@reduxjs/toolkit';
import { DropdownItemProps } from 'semantic-ui-react';

import { InsightsState } from 'app-redux/InsightsState';
import { mapToNumericDictionary } from 'utils/arrayHelpers';

const getAllDiseaseIds = (state: InsightsState) => state?.diseases?.allDiseaseIds;
const getDiseaseName = (diseaseId: number) => (state: InsightsState) => state?.diseases?.diseaseInformationByDiseaseId[diseaseId]?.name;
const getAllAvailableDiseases = (state: InsightsState) => state?.diseases?.allAvailableDiseases;
const getDiseaseGroups = (state: InsightsState) => state?.diseases?.diseaseGroups;
const isDiseasesLoading = (state: InsightsState) => state?.diseases?.isLoading;

const getAllDiseaseNamesById = createSelector(
  (state: InsightsState) => state?.diseases?.diseaseInformationByDiseaseId,
  byId => Object.values(byId ?? {}).reduce<Record<number, string>>((acc, item) => Object.assign(acc, { [item.id]: item.name }), {})
);
const allAvailableDiseasesById = createSelector(getAllAvailableDiseases, diseases =>
  mapToNumericDictionary(
    diseases,
    x => x.id,
    x => x
  )
);
const allAvailableDiseasesAsDropdownItem = createSelector(getAllAvailableDiseases, diseases =>
  diseases.map(({ id, name }) => ({ key: id, value: id, text: name } as DropdownItemProps))
);

export default {
  getAllDiseaseIds,
  getDiseaseName,
  getAllDiseaseNamesById,
  getAllAvailableDiseases,
  getDiseaseGroups,
  isDiseasesLoading,
  allAvailableDiseasesById,
  allAvailableDiseasesAsDropdownItem,
};
